const CHANGE_LOCALE = "chalk/intl/CHANGE_LOCALE";
const CHANGE_LOCALE_SUCCESS = "chalk/intl/CHANGE_LOCALE_SUCCESS";
const CHANGE_LOCALE_FAIL = "chalk/intl/CHANGE_LOCALE_FAIL";

const initialState = {
  locale: "es",
  messages: {},
  isLoading: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CHANGE_LOCALE:
      return {
        ...state,
        locale: action.locale,
        isLoading: true,
      };
    case CHANGE_LOCALE_SUCCESS:
      return {
        ...state,
        locale: action.locale,
        messages: action.result.default,
        isLoading: false,
      };
    case CHANGE_LOCALE_FAIL:
      return {
        ...state,
        locale: action.locale,
        isLoading: false,
      };
    default:
      return state;
  }
}

async function retrieveMessages(locale) {
  switch (locale) {
    case "eu":
      return await import("~/intl/messages/eu");
    case "es":
      return await import("~/intl/messages/es");
    case "ca":
      return await import("~/intl/messages/ca");
    case "de":
      return await import("~/intl/messages/de");
    case "fr":
      return await import("~/intl/messages/fr");
    case "it":
      return await import("~/intl/messages/it");
    case "nl":
      return await import("~/intl/messages/nl");
    case "pt":
      return await import("~/intl/messages/pt");
    case "ru":
      return await import("~/intl/messages/ru");
    case "ko":
      return await import("~/intl/messages/ko");
    case "da":
      return await import("~/intl/messages/da");
    default:
      return await import("~/intl/messages/en");
  }
}

export function changeLocale(locale) {
  return {
    types: [CHANGE_LOCALE, CHANGE_LOCALE_SUCCESS, CHANGE_LOCALE_FAIL],
    locale,
    promise: () => retrieveMessages(locale),
  };
}
